import { Hub } from "aws-amplify/utils";

const SESSION_EVENT_KEY = "competition-private-session-change";
const DRAFT_PREFIX = "director-drafts:";
let snapshot = { revision: 0, blocked: false };
let started = false;
const listeners = new Set();

export function clearPrivateRosterDrafts() {
  try {
    for (let index = sessionStorage.length - 1; index >= 0; index -= 1) {
      const key = sessionStorage.key(index);
      if (key?.startsWith(DRAFT_PREFIX)) sessionStorage.removeItem(key);
    }
  } catch { /* Private views must still close when storage is unavailable. */ }
}

export function invalidateCompetitionPrivateSession(event = "signedOut", broadcast = true) {
  clearPrivateRosterDrafts();
  snapshot = { revision: snapshot.revision + 1, blocked: event !== "signedIn" };
  listeners.forEach(listener => listener());
  if (broadcast) {
    try {
      // Only a session-change signal crosses tabs; never identities or tokens.
      localStorage.setItem(SESSION_EVENT_KEY, JSON.stringify({ event, nonce: `${Date.now()}:${Math.random()}` }));
    } catch { /* Focus revalidation also covers browsers without storage. */ }
  }
}

export function initializeCompetitionPrivateSession() {
  if (started) return;
  started = true;
  Hub.listen("auth", ({ payload }) => {
    if (["signedOut", "signedIn", "tokenRefresh_failure"].includes(payload.event)) {
      invalidateCompetitionPrivateSession(payload.event);
    }
  });
  window.addEventListener("storage", event => {
    if (event.key !== SESSION_EVENT_KEY || !event.newValue) return;
    try {
      const change = JSON.parse(event.newValue);
      if (["signedOut", "signedIn", "tokenRefresh_failure"].includes(change.event)) {
        invalidateCompetitionPrivateSession(change.event, false);
      }
    } catch { /* Ignore unrelated or malformed storage notifications. */ }
  });
}

export function getCompetitionPrivateSession() { return snapshot; }

export function subscribeCompetitionPrivateSession(listener) {
  initializeCompetitionPrivateSession();
  listeners.add(listener);
  return () => listeners.delete(listener);
}
